import { Seo } from "@/components/common/Seo";
import { PageHero } from "@/components/common/Kinetic";
import { CtaLink } from "@/components/common/Buttons";
import { Services } from "@/components/home/Services";
import { Process } from "@/components/home/Process";
import { FinalCta } from "@/components/home/FinalCta";

export default function ServicesPage() {
  return (
    <>
      <Seo path="/services" title="Software Development Services | Quantivo"
        description="SaaS product development, custom software, web portals, mobile apps, CRM and automation, and fintech payment API solutions from Quantivo, Kolkata." />
      <PageHero testId="services-hero" eyebrow="Services" lines={["Six practices.", "One engineering team."]}
        text="Whether you need a new product, an internal system or the integrations between them, we cover design, development, integration, launch and ongoing support.">
        <div className="mt-10"><CtaLink to="/contact" data-testid="services-hero-cta">Discuss Your Project</CtaLink></div>
      </PageHero>
      <Services index="01" />
      <Process index="02" />
      <FinalCta />
    </>
  );
}
